import sendCommand from './base';
const openUrlInExternalBrowser = (url) => {
    if (!url) {
        return false;
    }
    return sendCommand({
        command: 'action',
        params: {
            url: url,
            actionId: 'openExternalBrowser',
        },
    });
};
const actions = {
    openUrlInExternalBrowser
};
export default actions;
